import React, { Component, createRef  } from "react"
import { Card, CardBody, CardTitle,  Container, Row, Col } from "reactstrap"
import MetaTags from 'react-meta-tags';
import PropTypes from 'prop-types'
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";

import ReactToPrint from "react-to-print";
import Moment from "react-moment";

class OpenHouseFrm extends Component {
  constructor(props) {
    super(props)
    this.state = {
      projectData: '',
      formVisible: true,
      isLoading: true
    }
     this.componentRef = createRef();
  }

   componentDidMount() {
    const { match: { params } } = this.props;
    const { contactId } = params;
   axios
      .get(`https://rscoreapi.azurewebsites.net/api/ClientSellerOpenhouse/byguid?openhouseGuid=${contactId}`
      )
      .then((res) => {
        this.setState({ contactData: res.data });
      })
      .catch((error) => {
        console.error("There was an error fetching the data!", error);
      });
  }


  formatPhoneNumber(phone) {
    if (!phone) return '';
    const cleaned = ('' + phone).replace(/\D/g, '');
    const lastTen = cleaned.slice(-10);
    const match = lastTen.match(/^(\d{3})(\d{3})(\d{4})$/);
    if (match) {
      return `(${match[1]}) ${match[2]}-${match[3]}`;
    }
    return phone;
  }
   handlePrint = () => {
    window.print();
  };
  render() {
    const { contactData } = this.state;

    return (
      <React.Fragment>
       
        <MetaTags>
          <title>Openhouse | Realty Space</title>
        </MetaTags>
        <ToastContainer autoClose={2000} />
    
         
            <div className="page-content" style={{ paddingTop: 40 }}>

              <Container fluid>
               
                <Row>
                  <Col xl="3"></Col>
                  <Col xl="6">
                     
                          <button className="btn btn-primary float-end mb-3" onClick={this.handlePrint}>Print</button>
                       
                      <div className="clearfix"></div>
                     <div className="printableArea">
                     <Card className="newCard">

                              <CardBody>
                                <CardTitle className="mb-4">
                                  <h2 className="text-center" style={{fontWeight:'bold', fontFamily:'Arial Black'}}>OPEN HOUSE</h2>
                                  <p className="text-center" style={{fontWeight:'normal'}}>Address: {contactData?.clientListing?.listingAddress}</p>
                                   <p className="text-center" style={{fontWeight:'normal'}}>Date: <Moment format="DD MMM YYYY">{contactData?.openhouseDate}</Moment> / {contactData?.startTime} -  {contactData?.endTime} </p>
                                   <p className="text-center">Register Yourself Scan this QR code</p>
                                </CardTitle>
                                <Row>
                                  <Col sm="12" className="text-center">
                                    <img src={contactData?.qrImageUrl} alt="QR Code" className="img-fluid" />
                                  </Col>
                                  <Col sm="12" className="text-center" style={{marginTop:20} }>
                                     <h4 className="agentInfo"><strong>Agent Organization</strong><br />
                                                             <span>{contactData?.agentOrganization}</span>
                                                           </h4>
                                   
                                    </Col>
                                     <Col sm="12" className="text-center" style={{marginTop:20, marginBottom:20} }>
                                     <h4 className="agentInfo"><strong>Agent</strong><br />
                                                             <span>{contactData?.agentName}</span>
                                                           </h4>
                                   
                                    </Col>
                                  <Col sm="12" className="text-center" style={{marginTop:20, marginBottom:20} }>
                                   <Row>
                                                        
                                                         <Col sm="6">
                                                           <h4 className="agentInfo"><strong>Phone</strong><br />
                                                             <span>{contactData?.agentContact}</span>
                                                           </h4>
                                                         </Col>
                                                         <Col sm="6">
                                                           <h4 className="agentInfo"><strong>Email</strong><br />
                                                             <span>{contactData?.agentEmail}</span>
                                                           </h4>
                                                         </Col>
                                                       </Row>
                                  </Col>

                                  
                                  

                                </Row>

                              </CardBody>
                            </Card>
                      </div>
                  </Col>

                </Row>

              </Container>
            </div>
         
       
      </React.Fragment>
    )
  }
}
OpenHouseFrm.propTypes = {
  t: PropTypes.any,
  match: PropTypes.object,

}

export default OpenHouseFrm;


